<hr>
<div class="wizard-footer">
    <div class="mini-stepper">
        @for (step of steps(); track step.stepNumber; let i = $index; let isLast = $last) {
            <button type="button" class="dot"
                [class.active]="activeStep() === i" [class.done]="step.done" [class.invalid]="step.invalid"
                [disabled]="!canNavigateToStep(i)"
                [attr.aria-label]="'Step ' + step.stepNumber + (step.label ? ' - ' + step.label : '') + (step.invalid ? ' - Invalid' : '')"
                (click)="onStepClick($event, i)">{{ step.stepNumber }}</button>
            @if (!isLast) { <div class="line"></div> }
        }
    </div>
    <div class="footer-actions">
        @if (showCancel()) {
            <button type="button" class="secondary stepper-btn" (click)="cancelClicked.emit()">cancel</button>
        }
        @if (showBack()) {
            <button type="button" class="button secondary stepper-btn" [disabled]="isSubmitting()" (click)="stepChange.emit(activeStep() - 1)">back</button>
        }
        @if (showNext()) {
            <button type="button" class="button stepper-btn" (click)="stepChange.emit(activeStep() + 1)">next</button>
        }
        @if (showSubmit()) {
            <span class="submit-tooltip" [matTooltip]="submitTooltip()" matTooltipClass="submit-disabled-tooltip"
                [matTooltipDisabled]="!showSubmitTooltip()" matTooltipPosition="above">
                <button type="button" class="button stepper-btn" [disabled]="submitDisabled()" (click)="submitClicked.emit()">{{ isSubmitting() ? "submitting..." : "submit" }}</button>
            </span>
        }
    </div>
</div>
